import { StyleSheet } from 'react-native';

import { Button, ButtonProps } from '@pletly/ui';

export const GroupButton = ({ ...props }: ButtonProps) => {
	return <Button color="primary" size="small" variant="filled" style={styles.button} {...props} />;
};

const styles = StyleSheet.create({
	button: {
		flex: 1,
	},
});
